import { useMemo } from "react"
import { useQueryClient } from "@tanstack/react-query"

import { isPsyAccountPage } from "app/AppRouter/utils"
import { Headline3, Modal, Text } from "ui-kit/components-branded/index"
import { Call, GET_CALL_QUERY_KEY } from "modules/Call/queries"
import { useGetBookingHash } from "modules/Call/routing"
import { Spinner } from "components/Spinner"
import { textHasUrl, urlify } from "utils/helpers"
import style from "modules/Call/components/HelpMoreMenuWrapper/HelpModal/style.module.scss"

interface Props {
    isOpen?: boolean
    openToggle?: () => void
}

export function HelpModal({ isOpen, openToggle }: Props) {
    const queryClient = useQueryClient()
    const bookingHash = useGetBookingHash()
    const call = queryClient.getQueryData<Call>([GET_CALL_QUERY_KEY, bookingHash])
    const urlRegex = /(\w+:\/\/[^\s,]+)/g

    const content = useMemo(() => {
        if (isPsyAccountPage()) {
            return {
                phoneTitle: <>Телефон клиента</>,
                phone: call?.booking.client.phone,
            }
        } else {
            return {
                phoneTitle: <>Телефон для связи с&nbsp;психологом</>,
                phone: call?.booking.psychologist.private_number,
            }
        }
    }, [])

    const altConnectionLink = (text: string) => {
        const isUrl = textHasUrl(text)
        if (isUrl) {
            return (
                <div
                    dangerouslySetInnerHTML={{
                        __html: text.replace(urlRegex, (item) =>
                            urlify(item, undefined, "Перейти")
                        ),
                    }}
                />
            )
        }

        return text
    }

    return (
        <Modal isActive={isOpen} onBackgroundClick={openToggle}>
            <Modal.Content
                className={style.modalContent}
                data-testid="call-alternative-help-modal"
                onCloseClick={openToggle}
            >
                {!call ? (
                    <Spinner />
                ) : (
                    <>
                        <Headline3 className={style.title}>Альтернативный способ связи</Headline3>
                        <div className={style.warningBlock}>
                            Используйте этот&nbsp;способ, если&nbsp;ошибка не&nbsp;пропадает после
                            обновления страницы.
                        </div>
                        <Text className={style.connectToConferenceText}>
                            Подключиться к&nbsp;конференции
                        </Text>
                        <Text>
                            {altConnectionLink(call?.booking.psychologist.video_call_handle)}
                        </Text>
                        {content && (
                            <>
                                <br />
                                <hr />
                                <Text isAccent>Остались вопросы?</Text>
                                <br />
                                <Text>
                                    {content.phoneTitle}: <Text isNowrap>{content.phone}</Text>
                                </Text>
                            </>
                        )}
                    </>
                )}
            </Modal.Content>
        </Modal>
    )
}
